export function formatPhone(input: string): string {
  const value = input.replace(/\D/g, '');

  let normalizedValue = value;
  if (value.length === 9 || (value.length === 10 && !value.startsWith('7'))) {
    normalizedValue = '7' + value;
  } else if (value.length === 11 && value.startsWith('8')) {
    normalizedValue = '7' + value.slice(1);
  }

  const isValid =
    (normalizedValue.length === 10 || normalizedValue.length === 11) &&
    normalizedValue.startsWith('7');

  if (!isValid) {
    return input;
  }

  return `+7 (${normalizedValue.slice(1, 4)}) ${normalizedValue.slice(4, 7)} ${normalizedValue.slice(7, 9)} ${normalizedValue.slice(9, 11)}`;
}

export function unformatPhone(input: string): string {
  return input.replace(/\D/g, '');
}